"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgPhoneOff = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M35.707 12.293a1 1 0 010 1.414L24.123 25.292a15 15 0 001.813 1.358l.72-.721a3 3 0 013.164-.676c.836.312 1.705.529 2.6.647A2.998 2.998 0 0135 28.89v2.996a3 3 0 01-3.288 2.998 20.78 20.78 0 01-9.058-3.22 20.42 20.42 0 01-2.782-2.121l-6.165 6.164a1 1 0 01-1.414-1.414l9.604-9.606a1.01 1.01 0 01.076-.084l.077-.069 12.243-12.241a1 1 0 011.414 0zm-13 14.416l-1.42 1.418c.76.682 1.578 1.302 2.447 1.854a18.774 18.774 0 008.176 2.913A1 1 0 0033 31.89v-3.01a.998.998 0 00-.85-.999 13.845 13.845 0 01-3.032-.755.998.998 0 00-1.05.221l-1.27 1.27a1 1 0 01-1.202.162 17 17 0 01-2.89-2.07zM16.11 13L19.1 13a3.002 3.002 0 013.001 2.59c.117.885.334 1.754.645 2.588a3.002 3.002 0 01-.679 3.17l-1.27 1.27a1 1 0 01-1.414-1.415l1.266-1.266a1 1 0 00.224-1.057 13.817 13.817 0 01-.753-3.02 1.003 1.003 0 00-1.01-.86h-3a1 1 0 00-.996 1.072 18.79 18.79 0 002.915 8.194 1 1 0 01-1.678 1.088 20.807 20.807 0 01-3.227-9.084A3 3 0 0116.11 13z",
    id: "phone-off_svg__a"
  }));
};

var _default = SvgPhoneOff;
exports.default = _default;